<template>
  <div class="footer">
    <div class="footer-lang">
      <ion-select :label="$t('options.dislang')" :aria-label="$t('options.dislang')"
        @ionChange="changeLocale($event.detail.value)" :value="this.$root.$i18n.locale" interface="popover">
        <ion-select-option value="en">English</ion-select-option>
        <ion-select-option value="pt">Portuguese</ion-select-option>
        <ion-select-option value="es">Spanish</ion-select-option>
      </ion-select>
    </div>
    <div style="display:inline-block; text-align:center; margin-right:auto; margin-left:auto;">
      <ul style="padding-left:5px;" v-if="getEnv('APP_NAME') == 'ChoiceSocial'">
        <li class="footer-sm"><a href="https://choicesocial.co/about-us" target="=_blank">PikMobile</a></li>
        <li class="footer-sm"><a href="https://choicesocial.co" target="=_blank">{{ $t('navlinks.about') }}</a></li>
        <li class="footer-sm"><a href="https://choicesocial.us/u/discovercs" target="=_blank">Discover</a></li>
        <li class="footer-sm"><a href="https://choicesocial.co/help-center" target="=_blank">{{ $t('navlinks.support') }}</a></li>
        <li><a :href="getEnv('PRIVACY_PAGE')" target="=_blank">{{ $t('navlinks.privacy') }}</a></li>
        <li><a :href="getEnv('TERMS_PAGE')" target="=_blank">{{ $t('navlinks.terms') }}</a></li>
      </ul>
      <ul style="padding-left:5px;" v-if="getEnv('APP_NAME') == 'FrankSocial'">
        <li class="footer-sm"><a href="https://mypillow.com" target="=_blank">MyPillow</a></li>
        <li class="footer-sm"><a href="https://mystore.com" target="=_blank">MyStore</a></li>
        <li class="footer-sm"><a href="https://frankspeech.com" target="=_blank">FrankSpeech</a></li>
        <li class="footer-sm"><a href="https://lindelllegalfund.org/" target="=_blank">Lindell Offense</a></li>
        <li class="footer-sm"><a href="https://franksocial.com/profile/127501" target="=_blank">Mike Lindell</a></li>
        <li><a href="https://support.franksocial.com/hc/en-us/articles/4758513370135-FrankSocial-FAQs" target="=_blank">{{
          $t('navlinks.support') }}</a></li>
        <li><a :href="getEnv('PRIVACY_PAGE')" target="=_blank">{{ $t('navlinks.privacy') }}</a></li>
        <li><a :href="getEnv('MOBILE_TERMS_PAGE')" target="=_blank">{{ $t('navlinks.mobileterms') }}</a></li>
        <li><a :href="getEnv('TERMS_PAGE')" target="=_blank">{{ $t('navlinks.terms') }}</a></li>
      </ul>
    </div>
    <p v-if="getEnv('APP_NAME') == 'ChoiceSocial'" style="margin-top:0px; font-size: 0.8em;">{{ $t('navlinks.copyright')
    }}
      &copy; 2024 PikMobile Inc.</p>
  </div>
</template>


<script>
import getEnv from '@/utils/env'
import { IonSelect, IonSelectOption } from '@ionic/vue';

export default {
  name: 'FooterContainer',
  components: { IonSelect, IonSelectOption },

  setup() {
    return {
      getEnv
    }
  },
  methods: {
    changeLocale(select) {
      this.$root.$i18n.locale = select;
      return;
    },
  }
}
</script>
<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, .2);
  color: white;
  text-align: center;
  padding-bottom: 8px;

}

.footer ul {
  font-size: 0.9em;
  list-style-type: none;
  line-height: 0px;
}

.footer li {
  float: left;
}

.footer li a {
  display: block;
  color: white;
  text-align: left;
  padding: 12px;
  text-decoration: none;
}

.footer a {
  color: white;
}

.footer-lang {
    max-width:240px; 
    font-size: 0.9em; 
    margin-right:auto; 
    margin-left:auto;
}



@media (max-height: 690px) {
    .footer-sm {
     display:none;
    }
    .footer {
      max-height:120px;
    }
    .footer ul{
      padding: 0;
      margin:0;
    }
    .footer li{
        margin:4px;
        text-align: left;
    }
  }

  @media (max-height: 599px) {
    .footer {
       display:none;
    }
  }
</style>